module.exports = __webpack_public_path__ + "img/bell-ringing-01.e3a86fad.svg";